import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const ArrowRightIcon: FC<Props> = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z" />
    </svg>
  );
};
